<template>
    <div>
        <!-- OG/meta -->
        <vue-headful title="Create your Community - coapp" description="" />
        <div class="py-4 d-flex justify-content-center align-items-md-center">
            <div class="step-wrapper login-form p-4 bg-white round-unify text-center">
                <div v-if="!error">
                    <h2>{{ $t('success') }}</h2>
                    <h3 class="mt-1">{{ $t('wait') }}</h3>
                    <div class="mt-3">
                        <coLoadingIndicator />
                    </div>
                </div>
                <CoAlert v-else variant="yellow">
                    <CoText type="p1">{{ $t('errorcreation') }}</CoText>
                </CoAlert>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import i18n from 'vue-i18n';
import { get } from 'lodash';

import coLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';

export default {
    name: 'CreateSpaceAfterPayment',
    components: {
        CoAlert,
        coLoadingIndicator,
    },
    i18n: {
        messages: {
            en: {
                success: 'Great, you created your community!',
                wait: 'Please wait a second to be redirected...',
                errorcreation: 'There was an error creating your community. Please contact support via help.coapp.io',
            },
            de: {
                success: 'Super, du hast deine Community erstellt!',
                wait: 'Bitte warte einen Moment, um weitergeleitet zu werden...',
                errorcreation:
                    'Es gab einen Fehler beim Erstellen deiner Community. Bitte kontaktiere den Support über help.coapp.io',
            },
        },
    },
    data() {
        return {
            sessionID: this.$route.query.session_id,
            error: false,
        };
    },
    beforeCreate() {
        window.onload = (event) => {
            // log matomo event
            if (window && window._paq) {
                window._paq.push(['trackEvent', 'community-creation', 'community-creation-completed']);
            }
        };
    },
    async created() {
        const newSpace = JSON.parse(sessionStorage.getItem('new-space'));
        let response = {};
        let createdSpace = {};
        try {
            if (!this.sessionID || !newSpace) {
                throw new Error('No sessionId or newSpace object provided');
            }
            const request = {
                first_name: newSpace.FirstName,
                last_name: newSpace.LastName,
                email: newSpace.Email,
                password: newSpace.Password,
                space_name: get(newSpace, 'Space.Name', ''),
                timezone: get(newSpace, 'Space.Timezone', ''),
                plan_slug: newSpace.Plan,
                currency: 'EUR',
                stripe_session_id: this.sessionID,
                captcha_payload: newSpace.CaptchaPayload || '',
            };
            if (request.plan_slug === 'free') {
                request.plan_slug = '';
            }
            response = await axios({
                method: 'POST',
                url: '/new-space/create',
                data: request,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            createdSpace = response.data;
            sessionStorage.removeItem('new-space');

            // log matomo event
            if (window && window._paq) {
                const spaceID = get(response, 'data.ID', null);
                if (spaceID) {
                    window._paq.push(['setUserId', spaceID]); // set matomo userID for cross-session conversion tracking
                }
                // set custom variables for tracking
                window._paq.push(['setCustomVariable', 1, 'spaceID', spaceID, 'visit']);
                window._paq.push([
                    'setCustomVariable',
                    2,
                    'userID',
                    get(response, 'data.PaymentMethodeCreatedBy', null),
                    'visit',
                ]);
                window._paq.push([
                    'setCustomVariable',
                    3,
                    'customerID',
                    get(response, 'data.StripeCustomerID', null),
                    'visit',
                ]);
                // track event for successful community creation
                window._paq.push(['trackEvent', 'community-creation', 'community-creation-success']);
                window._paq.push(['trackEvent', 'community-creation', 'community-creation-completed']); // needed for funnel tracking
            }

            // redirect to new space URL
            const token = response.data.Token;
            this.$router.push({
                name: 'CreateSpaceSuccess',
                params: { domain: `${response.data.DomainName}/welcome?apptoken=${token}` },
            });
        } catch (error) {
            // error handling
            this.error = true;
            console.warn('Error while creating new space', error);
        }
    },
};
</script>
